import React from 'react';
import JobReports from './JobReports';

const RegionReports = () => <JobReports reportType="jobregion" />;

export default RegionReports;
